import Screenshot, { ScreenshotRef } from '../components/Screenshot'
import Source from '../components/Source'
import { Page } from './types'

type CreateCloudPoolProps = { }
const render = () => {
    return <div className="row">
        <div className="col-8">
            <p>A <b>pool</b> defines a group of one or more machines with the same specifications,
            that are started simultaenously and form a cluster. When your code submits a model to
            Gurobi Instant Cloud, it is being solved by one of the machines in the pool of your choice.
            You can define a pool as follows.</p>
            <ul>
                <li>Login on the Gurobi website <ScreenshotRef label="1"/></li>
                <li>At the top, click <i>Downloads &amp; Licenses</i> and then <i>Your Gurobi Licenses</i></li>
                <li>Scroll to the cloud license you want to use <ScreenshotRef label="2"/></li>
                <li>On the ride side in this table row, click <i>Open</i> ; you are redirected to Gurobi Instant Cloud</li>
                <li>In Gurobi Instant Cloud, on the left, choose <i>Servers</i> and then <i>Pools</i> <ScreenshotRef label="3"/></li>
                <li>At the top, click the <i>Create pool</i> button <ScreenshotRef label="4"/></li>
                <li>On the first tab <i>Info</i>, enter a name and description.</li>
                <li>On the second tab <i>License</i>, choose the number of Compute Servers to be started simultaneously.</li>
                <li>On the third tab <i>Options</i>, define how many jobs can be solved simultaenously on each machine (<i>Job limit</i>) and how quickly idle machines are shut down (<i>Idle shutdown</i>).</li>
                <li>On the fourth tab <i>Machine</i>, choose a cloud provider, region and machine type.</li>
                <li>Click the <i>Create</i> button at the bottom to create the pool.</li>
            </ul>
            <Source href="https://www.gurobi.com/documentation/{version}/cloud-guide/instantcloud/cloudmanager/pools.html"/>
        </div>
        <aside className="screenshots col-4">
            <Screenshot label="1" src="01-login.png"/>
            <Screenshot label="2" src="05-open-cloud.png"/>
            <Screenshot label="3" src="08-servers-pools.png"/>
            <Screenshot label="4" src="09-create-pool.png"/>
        </aside>
    </div>
}

const CreateCloudPool : Page<CreateCloudPoolProps> = { key: 'create-cloud-pool', title: 'Create an Instant Cloud pool', render }

export default CreateCloudPool